export const Guard = {
  ensure(validations: Array<{ isValid: boolean; errorMessage: string }>): void {
    for (const validation of validations) {
      if (!validation.isValid) {
        throw new Error(validation.errorMessage)
      }
    }
  },
}

export const valueIsPresent = (value: unknown, fieldName: string) => ({
  isValid: Array.isArray(value) ? value.length > 0 : !!value,
  errorMessage: `Missing required property "${fieldName}"`,
})
